import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import "./authors.m.css";
import { getTextToSlug } from "../../../utils";

const Authors = ({ story = {}, authorColor = "#231f20", authorSize }) => {
  const authorName = story["author-name"];
  const authorSlug = getTextToSlug(authorName);
  return (
    <div styleName="authors">
      {story.authors ? (
        story.authors.map(author => (
          <Link
            href={`/author/${author.slug}`}
            key={author.id}
            style={{ color: authorColor, fontSize: authorSize }}
          >
            <span styleName="author-name">{author.name}</span>
          </Link>
        ))
      ) : (
        <Link
          href={`/author/${authorSlug}`}
          style={{ color: authorColor, fontSize: authorSize }}
        >
          <span styleName="author-name">{authorName}</span>
        </Link>
      )}
    </div>
  );
};

Authors.propTypes = {
  story: PropTypes.object.isRequired,
  authorColor: PropTypes.string,
  authorSize: PropTypes.string
};

export default Authors;
